import { Scheduling, Schedule, WeekDay, WEEKDAY } from './scheduling.model';
import { GeneralService } from '../../shared/services/general.service';

export class SchedulingUtils {

    static formatSchedulesForDeviceList(schedules: Schedule[]): string {
        if (schedules.length === 0) {
          return '';
        } else if (schedules.length > 1) {
          return 'Multiple Schedules';
        } else {
          return `${this.filterWeekdays(schedules[0].getWeekDays())} |  ${schedules[0].getHorary()}`;
        }
      }

      static formatScheduleForDeviceDetail(schedule: Schedule): string {
        const weekdays: WeekDay[] = [];
        for (const wd of schedule.getWeekDays() ) {
          if (wd.getWeekDay() !== WEEKDAY.SUNDAY) {
            weekdays.push(wd);
          }
        }
        weekdays.push(schedule.getWeekDays()[0]);
        return this.filterWeekdays(weekdays);
      }

      static filterWeekdays(weekDays: WeekDay[]): string {
        return weekDays.filter(d => d.getSet())
                       .map(d => d.getWeekDay())
                       .join(' ');
      }

}



// WEBPACK FOOTER //
// ./src/app/entities/scheduling/shedulling.utils.ts